import styled from 'foundations-theming/utils';
import { CARD_BOX_SHADOW } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentCardWrapper = styled.div.withConfig({
  displayName: "ContentCard__ContentCardWrapper",
  componentId: "sc-14ipuf1-0"
})(["border-radius:4px;border-top:10px solid ", ";box-shadow:", ";height:100%;padding:16px 24px;"], ({
  theme
}) => theme.color['do-not-use-slinky'], CARD_BOX_SHADOW);

/**
 * **Deprecated**. Module and styles extracted from the existing CMS site — the
 * "old" styles. See
 * [the new Guides page](https://local.hubteamqa.com/docs-public/doc/cms/guides),
 * extracted from [the current live site](https://developers.hubspot.com/docs/cms/guides),
 * for an example.
 *
 * Eventually all cards will be migrated to the new card component, so please
 * use that for UX consistency instead.
 *
 * @deprecated
 */
const ContentCard = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ContentCardWrapper, {
    children: children
  });
};
export default ContentCard;